import qs from '@src/utils/query-string-util';

/**
 * 根据utm_source渠道替换PC下载链接
 * @param {*} downloadLink 原始下载链接
 * @returns 替换后的下载链接
 */
export const replaceDownloadLinkPc = downloadLink => {
  const searchParams = qs.getSearchParams();
  const utm_source = searchParams['utm_source'];

  const sourceList = ['bdsem', 'bdsem1', 'sgsem', 'sgsem1', 'smsem', 'smsem1', 'bisem', 'bisem1', '360sem', '360sem1', 'mnbk1', 'douyu', 'youdao8'];

  if (!!utm_source && sourceList.includes(utm_source)) {
    return downloadLink.replace('.exe', `-AT=${utm_source}.exe`);
  }
  return downloadLink;
};

/**
 * 根据utm_source渠道替换Android下载链接
 * @returns 替换后的下载链接
 */
export const replaceDownloadLinkAndroid = downloadLink => {
  const searchParams = qs.getSearchParams();
  const utm_source = searchParams['utm_source'];

  switch (utm_source) {
    case 'bdsem':
    case 'bdsem1':
      return 'https://cbjq-content.xoyocdn.com/ob202307/setup/ob202307/setup/Android/CBJQ_bdsem.bdsem1_30227.mtp.apk';
    case 'sgsem':
      return 'https://cbjq-content.xoyocdn.com/ob202307/setup/ob202307/setup/Android/CBJQ_sgsem_30020.mtp.apk';
    case 'sgsem1':
      return 'https://cbjq-content.xoyocdn.com/ob202307/setup/ob202307/setup/Android/CBJQ_sgsem1_30020.mtp.apk';
    case 'smsem':
      return 'https://cbjq-content.xoyocdn.com/ob202307/setup/ob202307/setup/Android/CBJQ_smsem_30020.mtp.apk';
    case 'smsem1':
      return 'https://cbjq-content.xoyocdn.com/ob202307/setup/ob202307/setup/Android/CBJQ_smsem1_30020.mtp.apk';
    case 'bisem':
      return 'https://cbjq-content.xoyocdn.com/ob202307/setup/ob202307/setup/Android/CBJQ_bisem_30020.mtp.apk';
    case 'bisem1':
      return 'https://cbjq-content.xoyocdn.com/ob202307/setup/ob202307/setup/Android/CBJQ_bisem1_30020.mtp.apk';
    case '360sem':
      return 'https://cbjq-content.xoyocdn.com/ob202307/setup/ob202307/setup/Android/CBJQ_360sem_30020.mtp.apk';
    case '360sem1':
      return 'https://cbjq-content.xoyocdn.com/ob202307/setup/ob202307/setup/Android/CBJQ_360sem1_30020.mtp.apk';
    case 'mnbk1':
      return 'https://cbjq-content.xoyocdn.com/ob202307/setup/ob202307/setup/Android/CBJQ_mnbk1_30020.mtp.apk';
    case 'douyu':
      return 'https://cbjq-content.xoyocdn.com/ob202307/setup/ob202307/setup/Android/CBJQ_douyu_30020.mtp.apk';

    case 'youdao8':
      return 'https://cbjq-content.xoyocdn.com/ob202307/setup/ob202307/setup/Android/CBJQ_youdao.youdao8_30020.mtp.apk';

    default:
      return downloadLink;
  }
};
